import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import { config } from './config';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import cors from "cors";
import Cookies from 'js-cookie';

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { useToast } from "vue-toastification";

import $ from 'jquery'; // Importa jQuery
window.$ = $; // Asigna `$` globalmente, para asegurarte de que se esté utilizando

import '@fortawesome/fontawesome-free/css/all.css';

import '@cyhnkckali/vue3-color-picker/dist/style.css'

// Configura Axios globalmente
axios.defaults.baseURL = config.apiUrl;
// Esto no se usa porque no se usa CSRF cuando el front y back no son monoliticos
//axios.defaults.withCredentials = true;
//axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.request.use(function (config) {
    //console.log('main');
    const token = Cookies.get('token');
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    } else {
        delete config.headers.Authorization; // Si no hay token, elimina el header
    }
    //console.log(config.headers);
    config.headers.Accept = 'application/json';
    return config;
}, error => Promise.reject(error));

axios.interceptors.response.use(response => response, error => {
    const toast = useToast();

    if (error.response && error.response.data && error.response.data.errors) {
        error.response.data.errors.forEach(messages => {
            console.log(messages);
            messages.forEach(message => {
                toast.error(message);
            });
        });
    } else if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
    } else if (error.response) {
        toast.error(`Error: ${error.response.status} - ${error.response.statusText}`);
    } else {
        toast.error('Error: Something went wrong!');
    }
    return Promise.reject(error);
});


createApp(App)
    .use(store)
    .use(router)
    .use(Toast, {
        position: 'top-right', // Posición del toast
        timeout: 5000, // Tiempo de duración (ms)
        closeOnClick: true, // Cerrar al hacer clic
        pauseOnHover: true, // Pausar cuando el mouse está sobre el toast
        draggable: true, // Hacer draggable
    })
    .use(cors)
    .mount('#app')

/*
function testConnection() {
    const toast = useToast();

    axios.get('/test-connection')
        .then(response => {
            toast.success('Conexión exitosa');
            console.log('Conexión exitosa:', response.data);
        })
        .catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Error en la conexión');
            }
            console.error('Error en la conexión:', error);
        });
}

testConnection();
*/